import { render, staticRenderFns } from "./box-form.vue?vue&type=template&id=4dc0b566&"
import script from "./box-form.vue?vue&type=script&lang=js&"
export * from "./box-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports